import LineTearComp from './LineTear';
import QuadrilateralComp from './Quadrilateral';

export default {
  LineTear: LineTearComp,
  Quadrilateral: QuadrilateralComp,
};
